import React from "react";
import { Mutation } from "react-apollo";
import Button from "@streeteasy/design-system/deprecated/Button";
import Input from "@streeteasy/design-system/deprecated/Input";
import Text from "@streeteasy/design-system/deprecated/Text";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { camelCase, mapKeys } from "lodash";
import { func, object, shape, string } from "prop-types";

import GlobalState from "../../../../../../../shared/utilities/globalState";
import { emailCaptureGA, setPasswordGA } from "../../../../analytics/ga";
import REGISTER from "../../../../mutations/register";
import {
  CreateButton,
  ModalHeading,
  ModalInput,
  ModalText,
  ModalTitle,
  SetPasswordWrapper,
  XButtonWrapper
} from "../../styled";

class PasswordRequiredToRegister extends React.Component {
  static defaultProps = {
    formError: ""
  };

  static propTypes = {
    form: shape({
      data: object,
      email: string,
      origin: string,
      password: string
    }).isRequired,
    formError: string,
    handleCloseModal: func.isRequired,
    handleInputChange: func.isRequired,
    handleMutationError: func.isRequired,
    handleRenderError: func.isRequired,
    setScenario: func.isRequired
  };

  // GA starts
  componentDidMount() {
    if (GlobalState.get("analyticsData")) {
      this.source = GlobalState.get("analyticsData").source || null;
    } else if (localStorage.getItem("analytics")) {
      this.source =
        JSON.parse(localStorage.getItem("analytics")).source || null;
    }

    setPasswordGA.setPasswordModalOpens(this.source, "industry");
    localStorage.setItem("analytics", JSON.stringify({ source: this.source }));
  }
  // GA ends

  handleCompleted = data => {
    // GA starts
    const analyticsData = mapKeys(data.register.analytics_data, (value, key) =>
      camelCase(key)
    );
    analyticsData.source = this.source;
    localStorage.setItem("analytics", JSON.stringify(analyticsData));
    emailCaptureGA.accountIsCreated(analyticsData.source, analyticsData.flow);
    localStorage.setItem("confirmationModalScenario", "setPassword");
    // GA ends

    if (data.register.is_industry) {
      this.props.setScenario("RegisterIndustryConfirmation", {
        email: this.props.form.email
      });
    } else if (GlobalState.hasCallbacks("passwordRequiredToRegister")) {
      GlobalState.runCallbacks("passwordRequiredToRegister");
      this.props.handleCloseModal();
    } else {
      window.location.reload();
    }
  };

  handleSubmit = mutationQuery => {
    mutationQuery({
      variables: {
        data: JSON.stringify(this.props.form.data),
        email: this.props.form.email,
        password: this.props.form.password,
        origin: this.props.form.origin
      }
    });
  };

  render() {
    return (
      <SetPasswordWrapper>
        <ModalHeading>
          <ModalTitle type="primarySm">Let’s set a password</ModalTitle>
          <XButtonWrapper>
            <XButton onClick={this.props.handleCloseModal} />
          </XButtonWrapper>
        </ModalHeading>
        <ModalText>
          <Text type="sm">That way, you can sign in more easily next time</Text>
        </ModalText>
        <Mutation
          mutation={REGISTER}
          onCompleted={this.handleCompleted}
          onError={this.props.handleMutationError}
        >
          {mutationQuery => (
            <form
              onSubmit={e => {
                this.handleSubmit(mutationQuery);
                e.preventDefault();
              }}
            >
              <ModalInput>
                <Input
                  autoFocus
                  isInvalid={this.props.formError}
                  name="password"
                  onChange={this.props.handleInputChange}
                  placeholder="Password (at least 5 characters)"
                  type="password"
                />
              </ModalInput>
              {this.props.handleRenderError()}
              <CreateButton>
                <Button theme="primary" type="submit">
                  Create
                </Button>
              </CreateButton>
            </form>
          )}
        </Mutation>
      </SetPasswordWrapper>
    );
  }
}

export default PasswordRequiredToRegister;
